// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

type Props = {
  classes: Object,
};

const HomeBlogHeader = ({ classes }: Props) => (
  <Typography type="heading2" gutterBottom className={classes.root}>
    Latest Blog Posts
  </Typography>
);

const styles = (theme) => ({
  root: {
    textAlign: "center",
    marginBottom: theme.spacing.unit * 2,
  },
});

export default withStyles(styles, { name: HomeBlogHeader })(HomeBlogHeader);
